import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-clinic',
  templateUrl: './our-clinic.component.html',
  styleUrls: ['./our-clinic.component.scss']
})
export class OurClinicComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
